import {useState, useEffect} from 'react'

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField"
import FormControl from "@mui/material/FormControl"

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ModalDialog from "components/ModalDialog/ModalDialog";

// Material Dashboard 2 React example components
import CashierLayout from "examples/LayoutContainers/CashierLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import PendingOffersTableData from "layouts/cashier/data/pendingOffersTableData";
import ModalPendingOffersData from "layouts/cashier/data/modalPendingOffersData"

import {searchBoxStyle} from "./styles/searchbox_style"
import CashierNavbar from 'examples/Navbars/CashierNavbar';

import { useTokenContext } from 'App';
import { getPendingOffers } from 'api/offer/getPendingOffers';
import {getPhotoSource} from "api/requests"
import {closeOffer} from "api/offer/closeOffer"
import {cancelOffer} from "api/offer/cancelOffer"

import {readStream} from "readStream/readStream"

function Cashier() {
  const [searchText, setSearchText] = useState('');
  const [indexPage, setIndexPage] = useState(0)
  const {token} = useTokenContext();
  const [pendingOffersResponse, setPendingOffersResponse] = useState(null);
  const [offer, setOffer] = useState(null)
  const [closeCancelResponse, setCloseCancelResponse] = useState(null)
  const [images, setImages] = useState(null)
  const { columns: columnOffers, pendingRows: rowOffers} = PendingOffersTableData(onActionClick, searchText, pendingOffersResponse, images,token);


  function onActionClick(offer){
    setOffer(offer)
    setShowModal(true);
  }

  const onCloseModalClick = () =>{
    setShowModal(false);
  }

  const handleTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleIndexPage = (index) => {
    setIndexPage(index)
  }
  
  const doCloseOffer = async () => {
    try{
      let closeCancelResponse = await closeOffer(offer['id'], token)
      setCloseCancelResponse(closeCancelResponse)
    } catch (error) {
      console.error("Error on closing offer: ", error)
    }
  }

  const doCancelOffer = async () => {
    try{
      let closeCancelPromise = await cancelOffer(offer['id'], token)
      setCloseCancelResponse(closeCancelPromise)
    } catch (error) {
      console.error("Error on canceling offer: ", error)
    }
  }

  const onCloseOfferClick = () => {
    doCloseOffer();
  }

  const onCancelOfferClick = () => {
    doCancelOffer();
  }

  const [showModal, setShowModal] = useState(false)
  const modalData = <ModalPendingOffersData offer={offer}/>

  const doGetPendingOffers = async () => {
    try {
      const pendingOffersResponse = await getPendingOffers(token);
      setPendingOffersResponse(pendingOffersResponse)

    } catch (error) {
      console.error("Error on get pending offers: ", error);
    }
  }


  useEffect(() => {
    if(pendingOffersResponse){
        let photos = {};
        for(var i=0; i < pendingOffersResponse["data"].length; i++){
          const avatarPhotoId = pendingOffersResponse['data'][i]['avatar']['photo_id']
          const productPhotoId = pendingOffersResponse['data'][i]['product']['product_photos_ids'][0]
          if(localStorage.getItem(avatarPhotoId) === null){
            getPhotoSource(avatarPhotoId, token)
            .then(response => {
              const reader = response.body.getReader();
              readStream(reader)
              .then(base64Response => {
                localStorage.setItem(avatarPhotoId, base64Response)
              })
              
            })
          }
          if(localStorage.getItem(productPhotoId) === null){
            getPhotoSource(productPhotoId, token)
            .then(response => {
              const reader = response.body.getReader();
              readStream(reader)
              .then(base64Response => {
                localStorage.setItem(productPhotoId, base64Response)
              })
              
            })
          }
        }
        setImages(photos)
      }
  }, [pendingOffersResponse, token]);

  
  useEffect(() => {
    doGetPendingOffers();
  },[]);

  useEffect(() => {
    const interval = setInterval(() => {
      doGetPendingOffers();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if(closeCancelResponse){
      doGetPendingOffers();
      setShowModal(false)
      setCloseCancelResponse(null);
    }
  }, [closeCancelResponse]);

  return (
    <>
    {(columnOffers && rowOffers) && (
    <>
    <CashierLayout>
      <CashierNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
              <MDBox sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <FormControl sx={{ m: 1, width: '40ch' }}>
                  <TextField fullWidth label="Search offer code..." onChange={handleTextChange} InputLabelProps={searchBoxStyle.placeholder} sx={[searchBoxStyle.text, searchBoxStyle.border]} variant="outlined" />
                </FormControl>
              </MDBox>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                >
                  <MDTypography variant="h6" color="white">
                    Pending offers
                  </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: columnOffers, rows: rowOffers }}
                  isSorted={false}
                  canSearch={true}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  handleIndexPage={handleIndexPage}
                  indexPage={indexPage}
                  visibleHead={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </CashierLayout>
    {showModal &&
      <ModalDialog 
        onCloseModalClick={onCloseModalClick} 
        onRightButtonClick={onCloseOfferClick} 
        onLeftButtonClick={onCancelOfferClick} 
        leftButton={"Cancel offer"}
        rightButton={"Close Offer"}
        title="Close Deal" 
        content={modalData}
        
      />
    }
    </>
    )}
    </>
  );
}

export default Cashier;
